import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";

// Recznie utrzymywana lista — zrodlem prawdy jest backend/server.py.
// "connected: true" = endpoint jest faktycznie wolany gdzies w kodzie frontendu (sprawdzone przez grep po ${API}/...).
const API_GROUPS = [
  {
    category: "Autoryzacja",
    endpoints: [
      { method: "GET", path: "/api/auth/login", desc: "Generuje URL logowania Spotify", connected: true },
      { method: "GET", path: "/api/auth/callback", desc: "Callback OAuth — wymienia kod na token, przekierowuje do frontendu", connected: true },
      { method: "POST", path: "/api/auth/refresh", desc: "Odswieza wygasly access token", connected: true },
    ],
  },
  {
    category: "Profil i dane Spotify",
    endpoints: [
      { method: "GET", path: "/api/spotify/me", desc: "Profil uzytkownika — swiadomie niepodlaczony, dane przychodza juz z /auth/callback", connected: false },
      { method: "GET", path: "/api/spotify/top-artists", desc: "Top artysci uzytkownika", connected: true },
      { method: "GET", path: "/api/spotify/top-tracks", desc: "Top utwory uzytkownika", connected: true },
      { method: "GET", path: "/api/spotify/saved-tracks", desc: "Polubione utwory — swiadomie niepodlaczony, dashboard czyta polubione z lokalnego cache", connected: false },
      { method: "GET", path: "/api/spotify/playlists", desc: "Playlisty uzytkownika", connected: true },
      { method: "GET", path: "/api/spotify/playlist/{id}", desc: "Utwory z playlisty — Spotify zwraca 403 dla tej aplikacji od 2026-08-06, wiec UI go nie wola", connected: false },
    ],
  },
  {
    category: "Ostatnio odtwarzane",
    endpoints: [
      { method: "GET", path: "/api/spotify/recently-played", desc: "Historia ostatnio odtworzonych utworow", connected: true },
    ],
  },
  {
    category: "Stan odtwarzania i urzadzenia",
    endpoints: [
      { method: "GET", path: "/api/spotify/playback-state", desc: "Pelny stan odtwarzania: urzadzenie, utwor, postep, shuffle/repeat", connected: true },
      { method: "GET", path: "/api/spotify/currently-playing", desc: "Sam odtwarzany utwor — swiadomie niepodlaczony, /playback-state zwraca to i wiecej", connected: false },
      { method: "GET", path: "/api/spotify/devices", desc: "Lista dostepnych urzadzen Spotify Connect", connected: true },
    ],
  },
  {
    category: "Sterowanie odtwarzaniem",
    endpoints: [
      { method: "PUT", path: "/api/spotify/playback/play", desc: "Start/wznowienie odtwarzania (wymaga Premium)", connected: true },
      { method: "PUT", path: "/api/spotify/playback/pause", desc: "Pauza", connected: true },
      { method: "POST", path: "/api/spotify/playback/next", desc: "Nastepny utwor", connected: true },
      { method: "POST", path: "/api/spotify/playback/previous", desc: "Poprzedni utwor", connected: true },
      { method: "PUT", path: "/api/spotify/playback/seek", desc: "Przewijanie do pozycji", connected: true },
      { method: "PUT", path: "/api/spotify/playback/volume", desc: "Ustawienie glosnosci", connected: true },
      { method: "PUT", path: "/api/spotify/playback/shuffle", desc: "Wlacz/wylacz losowe odtwarzanie", connected: true },
      { method: "PUT", path: "/api/spotify/playback/repeat", desc: "Tryb powtarzania (utwor/playlista/wylaczony)", connected: true },
      { method: "PUT", path: "/api/spotify/playback/transfer", desc: "Przeniesienie odtwarzania na inne urzadzenie", connected: true },
    ],
  },
  {
    category: "Obserwowanie (follow)",
    endpoints: [
      { method: "GET", path: "/api/spotify/following", desc: "Lista obserwowanych artystow (jedna strona)", connected: true },
      { method: "GET", path: "/api/spotify/following/all", desc: "PELNA lista obserwowanych (paginacja kursorowa) — zrodlo stanu przyciskow obserwowania", connected: true },
      { method: "GET", path: "/api/spotify/following/contains", desc: "Sprawdza czy user obserwuje artystow — Spotify zwraca 403 dla tej aplikacji, UI uzywa /following/all", connected: false },
      { method: "PUT", path: "/api/spotify/follow", desc: "Obserwuj artystow", connected: true },
      { method: "DELETE", path: "/api/spotify/follow", desc: "Przestan obserwowac artystow", connected: true },
    ],
  },
  {
    category: "Katalog artysty",
    endpoints: [
      { method: "GET", path: "/api/spotify/artist/{id}", desc: "Szczegoly artysty: gatunki, popularnosc, followersi", connected: true },
      { method: "GET", path: "/api/spotify/artist/{id}/albums", desc: "Albumy artysty", connected: true },
      { method: "GET", path: "/api/spotify/artist/{id}/top-tracks", desc: "Top utwory artysty", connected: true },
    ],
  },
  {
    category: "Przegladanie",
    endpoints: [
      { method: "GET", path: "/api/spotify/new-releases", desc: "Nowosci plytowe — UI wola, ale Spotify zwraca 403 dla tej aplikacji (ograniczenie jak audio-features, nie problem ze scope)", connected: true },
    ],
  },
  {
    category: "Biblioteka (Liked Songs / albumy)",
    endpoints: [
      { method: "PUT", path: "/api/spotify/library/tracks", desc: "Zapisz utwory do biblioteki", connected: true },
      { method: "DELETE", path: "/api/spotify/library/tracks", desc: "Usun utwory z biblioteki", connected: true },
      { method: "GET", path: "/api/spotify/library/tracks/contains", desc: "Sprawdz czy utwory zapisane — Spotify zwraca 403, UI uzywa /library/saved-track-ids (lokalny cache)", connected: false },
      { method: "PUT", path: "/api/spotify/library/albums", desc: "Zapisz albumy do biblioteki", connected: true },
      { method: "DELETE", path: "/api/spotify/library/albums", desc: "Usun albumy z biblioteki", connected: true },
      { method: "GET", path: "/api/spotify/library/albums/contains", desc: "Sprawdz czy albumy zapisane — Spotify zwraca 403, UI uzywa /library/album-ids", connected: false },
      { method: "GET", path: "/api/spotify/library/album-ids", desc: "ID wszystkich zapisanych albumow — zamiennik zablokowanego albums/contains", connected: true },
    ],
  },
  {
    category: "Okladka playlisty",
    endpoints: [
      { method: "PUT", path: "/api/spotify/playlist/{id}/image", desc: "Wgraj wlasna okladke playlisty (base64 JPEG)", connected: true },
    ],
  },
  {
    category: "Biblioteka lokalna (synchronizacja)",
    endpoints: [
      { method: "POST", path: "/api/library/sync", desc: "Uruchamia pelna synchronizacje biblioteki Spotify do lokalnej bazy (w tle)", connected: true },
      { method: "GET", path: "/api/library/sync/status", desc: "Status/postep synchronizacji", connected: true },
      { method: "GET", path: "/api/library/stats", desc: "Liczby rekordow zapisanych lokalnie", connected: true },
      { method: "GET", path: "/api/library/saved-track-ids", desc: "ID polubionych utworow z lokalnej kopii — zamiennik zablokowanego tracks/contains, zero zapytan do Spotify", connected: true },
    ],
  },
  {
    category: "Analiza audio (iTunes + DSP)",
    endpoints: [
      { method: "GET", path: "/api/audio/itunes-preview", desc: "Szuka fragmentu audio (iTunes, 30s) dla utworu — odtwarzanie probek w Top Utworach", connected: true },
      { method: "GET", path: "/api/audio/dsp-features", desc: "Realne cechy DSP (tempo, energia, barwa) dla utworu — test pojedynczego utworu w panelu Analiza audio", connected: true },
      { method: "POST", path: "/api/audio/analyze-batch", desc: "Uruchamia analize DSP dla listy utworow, w tle, z throttlingiem", connected: true },
      { method: "GET", path: "/api/audio/analyze-batch/status", desc: "Status/postep analizy DSP", connected: true },
      { method: "GET", path: "/api/audio/coverage", desc: "Statystyka pokrycia analizy DSP w globalnym cache", connected: true },
    ],
  },
  {
    category: "AI / Rekomendacje (Sonic DNA)",
    endpoints: [
      { method: "GET", path: "/api/ai/providers", desc: "Lista providerow AI ze statusem konfiguracji", connected: true },
      { method: "POST", path: "/api/recommendations/generate", desc: "Generuje analize Sonic DNA i rekomendacje artystow", connected: true },
      { method: "POST", path: "/api/recommendations/save-playlist", desc: "Zapisuje rekomendacje jako playliste w Spotify", connected: true },
      { method: "GET", path: "/api/recommendations/history", desc: "Historia wygenerowanych rekomendacji", connected: true },
      { method: "GET", path: "/api/recommendations/feedback", desc: "Historia kciuk gora/dol", connected: true },
      { method: "POST", path: "/api/recommendations/feedback", desc: "Zapisuje kciuk gora/dol na rekomendacji", connected: true },
      { method: "GET", path: "/api/profile/sonic-dna", desc: "Wszystkie zapisane genomy Sonic DNA usera", connected: true },
      { method: "DELETE", path: "/api/profile/sonic-dna", desc: "Usuwa zapisany genom", connected: true },
    ],
  },
  {
    category: "System",
    endpoints: [
      { method: "GET", path: "/api/", desc: "Health check — status API (uzywany przez monitoring, nie przez UI)", connected: false },
      { method: "GET", path: "/api/health", desc: "Health check — czy Spotify jest skonfigurowany (uzywany przez monitoring, nie przez UI)", connected: false },
    ],
  },
];

const METHOD_COLORS = {
  GET: "text-[#4ADE80] border-[#4ADE80]/30 bg-[#4ADE80]/10",
  POST: "text-[#60A5FA] border-[#60A5FA]/30 bg-[#60A5FA]/10",
  PUT: "text-[#FBBF24] border-[#FBBF24]/30 bg-[#FBBF24]/10",
  DELETE: "text-[#F87171] border-[#F87171]/30 bg-[#F87171]/10",
};

export const ApiStatusPage = () => {
  const navigate = useNavigate();

  const allEndpoints = API_GROUPS.flatMap((g) => g.endpoints);
  const connectedCount = allEndpoints.filter((e) => e.connected).length;
  const totalCount = allEndpoints.length;

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="api-status-page">
      <header className="glass sticky top-0 z-50 border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-white">Panspoti API</h1>
            <p className="text-xs text-[#A1A1AA] mt-0.5">Pelna lista endpointow backendu — podlaczone i niepodlaczone do UI</p>
          </div>
          <Button
            variant="ghost"
            onClick={() => navigate("/dashboard")}
            className="text-[#A1A1AA] hover:text-white hover:bg-white/5"
          >
            ← Dashboard
          </Button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 gap-4 mb-8">
          <Card className="bg-[#121212] border-[#27272A]">
            <CardContent className="pt-6">
              <div className="text-3xl font-bold text-[#4ADE80]">{connectedCount}</div>
              <div className="text-sm text-[#A1A1AA] mt-1">Podlaczone do UI</div>
            </CardContent>
          </Card>
          <Card className="bg-[#121212] border-[#27272A]">
            <CardContent className="pt-6">
              <div className="text-3xl font-bold text-[#A1A1AA]">{totalCount - connectedCount}</div>
              <div className="text-sm text-[#A1A1AA] mt-1">Tylko backend</div>
            </CardContent>
          </Card>
        </div>

        <div className="space-y-6">
          {API_GROUPS.map((group) => (
            <Card key={group.category} className="bg-[#121212] border-[#27272A]">
              <CardHeader className="pb-3">
                <CardTitle className="text-base text-white">{group.category}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                {group.endpoints.map((ep) => (
                  <div
                    key={`${ep.method}-${ep.path}`}
                    className="flex items-start gap-3 py-2 border-t border-[#1F1F22] first:border-t-0 first:pt-0"
                  >
                    <span
                      className={`shrink-0 w-16 text-center text-[10px] font-mono font-bold px-2 py-1 rounded border ${METHOD_COLORS[ep.method]}`}
                    >
                      {ep.method}
                    </span>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <code className="text-sm text-white font-mono">{ep.path}</code>
                        {ep.connected ? (
                          <Badge className="bg-[#4ADE80]/15 text-[#4ADE80] border-0 text-[10px]">Podlaczone</Badge>
                        ) : (
                          <Badge className="bg-white/5 text-[#71717A] border-0 text-[10px]">Tylko backend</Badge>
                        )}
                      </div>
                      <p className="text-xs text-[#A1A1AA] mt-0.5">{ep.desc}</p>
                    </div>
                  </div>
                ))}
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};
